var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 30",
    style: {
      enableBackground: "new 0 0 160 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5F63F2;}\n\t.st1{fill:#0D0D33;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,13.4c0.2,0.1,0.4,0.2,0.6,0.2c3.9,1.8,7.7,3.6,11.5,5.3c0.4,0.2,0.6,0.2,1-0.2c1.5-1.6,3-3.1,4.5-4.6 c0.1-0.1,0.2-0.2,0.4-0.2c-0.3,0.6-0.6,1.4-1,2c-0.8,1.1-0.6,2,0.2,3c0.6,0.7,1,1.6,1.7,2.3c0.5-4.5,0.9-9,1.4-13.6 c-3.4,2.4-6.7,4.7-10,7c0,0-0.1-0.1-0.1-0.1c0.6-0.8,1.3-1.7,2-2.6C8.7,9.1,5,6.4,1.3,3.6c1.8-2.2,4.2-3.4,7-3.6s5.2,0.8,7.3,2.7 c0.7-0.5,1.3-1,2-1.4c5.8-3.3,13,0,14.3,6.5c0.6,3.2-0.1,6-2.4,8.4c-3,3.1-6.1,6.1-9.1,9.2c-1.4,1.4-2.9,2.9-4.3,4.4 c-0.3,0.3-0.5,0.3-0.8,0C11,25.5,6.7,21.2,2.4,16.9C1.6,16.1,0.9,15,0.2,14c-0.1-0.1-0.1-0.3-0.2-0.4C0,13.6,0,13.5,0,13.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.3,16.3l2.6-0.8c0.2,1.8,1.6,3,3.3,3c1.6,0,2.6-0.7,2.6-1.9c0-3.2-7.9-1.4-7.9-6.8c0-2.4,2.2-4.1,5.2-4.1 c2.8,0,5.1,1.5,5.6,3.8l-2.6,1.1c-0.3-1.5-1.4-2.4-3-2.4c-1.4,0-2.3,0.6-2.3,1.6c0,2.7,8,0.7,8,6.8c0,2.6-2.3,4.4-5.6,4.4 C41.1,21,38.6,19,38.3,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,21c-2.2,0-3.8-1.2-3.8-3.7v-5h-1.8v-2.3h1.8V6.9h2.7v3.2h2.7v2.3h-2.7V17c0,1,0.6,1.6,1.4,1.6 c0.4,0,0.9-0.1,1.3-0.2l0.2,2.4C57.2,20.9,56.6,21,56,21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.9,12.4c-1.5,0-2.9,1.2-2.9,4.4v4h-2.7V10.1H62V12c0.5-1.2,1.9-2.1,3.2-2.1c0.4,0,0.9,0.1,1.2,0.2l-0.2,2.6 C65.9,12.5,65.4,12.4,64.9,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.5,6.8c0-0.9,0.7-1.6,1.7-1.6s1.7,0.7,1.7,1.6c0,0.9-0.7,1.7-1.7,1.7C68.2,8.4,67.5,7.7,67.5,6.8z  M67.8,10.1h2.7v10.7h-2.7V10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.8,16.1l-1.3,1.2v3.5h-2.7V5.7h2.7v8.1l4.1-3.8h3.4l-4.4,4.2l4.7,6.5h-3.2L76.8,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.3,6.8c0-0.9,0.7-1.6,1.7-1.6s1.7,0.7,1.7,1.6c0,0.9-0.7,1.7-1.7,1.7C85,8.4,84.3,7.7,84.3,6.8z M84.6,10.1 h2.7v10.7h-2.7V10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.7,10.1h2.7v1.6c0.7-1,1.9-1.8,3.4-1.8c2.4,0,3.9,1.5,3.9,3.9v7H97v-6.4c0-1.2-0.8-2.1-2-2.1 c-1.6,0-2.6,1.4-2.6,3.8v4.7h-2.7L89.7,10.1L89.7,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.2,10.1v10.1c0,2.8-2.1,4.7-5.3,4.7c-2.5,0-4.6-1.4-4.9-3.3l2.5-0.4c0.1,1,1.1,1.6,2.4,1.6 c1.6,0,2.7-0.9,2.7-2.3v-1.2c-0.5,0.8-1.7,1.2-3,1.2c-3.2,0-5-2.1-5-5.3s1.8-5.3,4.9-5.3c1.3,0,2.4,0.5,3,1.2v-1.1 C109.5,10.1,112.2,10.1,112.2,10.1z M109.7,15.2c0-1.8-1.1-3-2.7-3c-1.6,0-2.7,1.2-2.7,3s1.1,2.9,2.7,2.9S109.7,17,109.7,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.7,5.9h4.9c4.1,0,7.6,2.5,7.6,7.5s-3.5,7.5-7.6,7.5h-4.9V5.9z M119.3,18.3c2.6,0,5-1.3,5-4.9s-2.4-5-5-5 h-1.8v9.9H119.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.9,14.3v6.5h-2.6v-1.6c-0.6,1-1.9,1.7-3.2,1.7c-2.1,0-3.6-1.4-3.6-3.2c0-2.1,1.6-3.2,4.8-3.6l2-0.2v-0.1 c0-1.2-0.8-1.9-2.1-1.9c-1.2,0-2,0.7-2.1,1.9l-2.4-0.4c0.3-2.1,2.2-3.5,4.5-3.5C136,9.9,137.9,11.4,137.9,14.3z M135.3,16.2v-0.2 l-2,0.2c-1.4,0.2-2.2,0.8-2.2,1.5c0,0.7,0.6,1.3,1.6,1.3C134.4,19,135.3,17.7,135.3,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.4,17.8l2.2-0.9c0.3,1.1,1.1,2,2.5,2c1,0,1.7-0.5,1.7-1.2c0-2-5.9-0.7-5.9-4.7c0-1.7,1.5-3,3.8-3 c2.1,0,3.9,1.1,4.3,2.6l-2.2,0.9c-0.3-1-1.3-1.6-2.1-1.6c-0.9,0-1.4,0.3-1.4,1c0,1.9,5.9,0.4,5.9,4.7c0,1.8-1.7,3.3-4.1,3.3 C141.5,21,139.9,19.4,139.4,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.9,5.7h2.7v6c0.7-1.2,1.9-1.8,3.4-1.8c2.4,0,4,1.5,4,3.9v7h-2.7v-6.4c0-1.3-0.8-2.1-2.1-2.1 c-1.7,0-2.6,1.4-2.6,3.8v4.6h-2.7L149.9,5.7L149.9,5.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/Logo_Dark.db232679b2bb823c0f8e9bf61409a94c.svg";
export { ForwardRef as ReactComponent };